import { render, staticRenderFns } from "./LockModal.vue?vue&type=template&id=3c83cbb6&"
import script from "./LockModal.vue?vue&type=script&lang=js&"
export * from "./LockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports